import useApp from "./app";
import { useCartStore } from "../stores";
import { getCheckoutGate } from "../utils/checkoutGate";

const useCheckoutGate = () => {
  const { timeBannerMessage, minimumOrder } = useApp();
  const subtotal = useCartStore((state) => state.subtotal);
  return getCheckoutGate({
    subtotal,
    minimumOrder,
    timeBannerMessage,
  });
};

export default useCheckoutGate;
